import React, { useState } from 'react';
import { Popover, RadioButton, Text } from '@oneaudi/unified-web-components';
import { useTranslation } from 'react-i18next';
import { Filter, FilterFrame, FilterSelection } from '../Filters.style';
import FilterExposedHeader from '../FilterExposedHeader';
import useAnimations from '../../../hooks/Animations/useAnimations';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import { FilterOption } from '../../../types';
import { RadioButtonWrapper, VehicleTypeWrapper } from './VehicleType.styles';
import { ButtonStyled, InfoIconWrapper } from '../../CheckboxComponent/CheckboxSelector.styles';

interface VehicleTypeProps {
  filterType: string;
  vehicleTypeOptions: {
    [key: string]: FilterOption;
  };
  confirmedFilters: FilterTypes;
  // eslint-disable-next-line react/no-unused-prop-types
  availableFilters: string[];
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string, isChecked?: boolean) => void;
  handleExposeFilter: (arg: string) => void;
}

const VehicleType: React.FC<VehicleTypeProps> = ({
  filterType,
  vehicleTypeOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const listOfvehicleTypes = Object.keys(vehicleTypeOptions);
  const showFilter = openedFiltersList[filterType];

  const selectedTypeLabel = vehicleTypeOptions[confirmedFilters.vehicleType].label as string;
  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);
  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedTypeLabel}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props}>
              <FilterFrame style={filtersAccordianAnimation}>
                <VehicleTypeWrapper data-testid="vehicleType-list">
                  {listOfvehicleTypes.map((vehicleType) => {
                    const vehicleTypeObject = vehicleTypeOptions[vehicleType];
                    const { value } = vehicleTypeObject;
                    return (
                      <RadioButtonWrapper>
                        <RadioButton
                          key={vehicleTypeObject.value}
                          checked={vehicleTypeObject.value === confirmedFilters.vehicleType}
                          data-testid={`vehicleType-list-${vehicleTypeObject.value}`}
                          id="RadioButton-id-a"
                          label={vehicleTypeObject.label as string}
                          value={value}
                          margin={[0, 0, 0, 0]}
                          name="story"
                          onClick={() => handleAddFilter(filterType, vehicleTypeObject.value)}
                        />
                        {value === 'USED-CAR' && (
                          <InfoIconWrapper>
                            <Popover
                              aria-label="Popover title"
                              id="popover_title"
                              triggerElement={
                                <ButtonStyled
                                  variant="tertiary"
                                  icon="info-circle"
                                  size="sm"
                                  onClick={() => setIsOpen(!isOpen)}
                                />
                              }
                              open={isOpen}
                              content={
                                <>
                                  <Text
                                    variant={{
                                      order: '2',
                                      style: 'normal',
                                    }}
                                  >
                                    {t(`promo.filters.filterOptions.vehicleType.popover`)}
                                  </Text>
                                </>
                              }
                              onClose={() => setIsOpen(false)}
                              withTip
                            />
                          </InfoIconWrapper>
                        )}
                      </RadioButtonWrapper>
                    );
                  })}
                </VehicleTypeWrapper>
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default VehicleType;
